export const DEFAULT_COL_WIDTH = 140
export const MIN_COL_WIDTH = 12
export const MAX_COL_WIDTH = 800
export const DEFAULT_ROW_HEIGHT = 28
export const MIN_ROW_HEIGHT = 12
export const MAX_ROW_HEIGHT = 600
